import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Bell, CheckCircle2, FileText, CreditCard, Calendar } from "lucide-react";

const KIND_ICON = { document: FileText, filing: Calendar, billing: CreditCard, deadline: Bell, system: Bell };

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/notifications");
    setItems(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="hs-overline text-blue-700">INBOX</div>
          <h1 className="font-display font-black text-4xl uppercase tracking-tighter mt-2">Notifications</h1>
        </div>
        <button onClick={markAll} className="hs-btn-secondary" data-testid="mark-all-read">MARK ALL READ</button>
      </div>

      <div className="hs-card divide-y divide-slate-200">
        {loading && <div className="p-6 hs-overline">LOADING…</div>}
        {!loading && items.length === 0 && <div className="p-12 text-sm text-slate-500 text-center">All caught up.</div>}
        {items.map((n) => {
          const Icon = KIND_ICON[n.kind] || Bell;
          return (
            <div key={n.id} className={`flex items-start gap-3 px-5 py-4 ${!n.read ? "bg-slate-50" : ""}`} data-testid={`notification-${n.id}`}>
              <div className={`mt-0.5 ${n.read ? "text-slate-500" : "text-blue-700"}`}><Icon size={16} /></div>
              <div className="flex-1 min-w-0">
                <div className="text-sm">{n.title}</div>
                <div className="text-xs font-mono text-slate-500 mt-1">{n.kind?.toUpperCase()} · {(n.created_at || "").slice(0, 16).replace("T", " ")}</div>
              </div>
              {!n.read && (
                <button onClick={() => markOne(n.id)} className="hs-btn-ghost text-xs p-1.5" data-testid={`mark-read-${n.id}`}>
                  <CheckCircle2 size={14} />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
